import React, { Component } from "react";
import { injectIntl } from "react-intl";

import "wxrecall/components/SearchInput.css";

import SearchInputControls from "wxrecall/components/SearchInputControls";

const settings = window.settings;

/**
 * Left panel main container for bulletin recall.
 * See also WeatherSearchInput for weather recall left panel
 */
export class BulletinSearchInput extends Component {
  constructor(props) {
    super(props);

    this.component = React.createRef();
    this.headerInput = React.createRef();
    this.issueSiteInput = React.createRef();

    this.updateRequestState = this.props.updateRequestState;
    this.networkManager = this.props.networkManager;

    // We want to capture when any keys are pressed on this page.
    window.onkeydown = this.onKeyDown.bind(this);
  }

  onKeyDown = e => {
    if (
      e.key === "Enter" &&
      this.component.current.contains(window.document.activeElement)
    ) {
      this.search();
    }
  };

  getQueryString = () => {
    let headerString = this.headerInput.current.value
      ? `header=${this.headerInput.current.value}`
      : "";
    let issueSiteString = this.issueSiteInput.current.value
      ? `issue_site=${this.issueSiteInput.current.value}`
      : "";

    let queryString =
      "?" + [headerString, issueSiteString].filter(string => string).join("&");

    return queryString;
  };

  search() {
    // Clear out any existing search result data
    this.props.searchCallback([]);

    if (this.headerInput.current.value || this.issueSiteInput.current.value) {
      const queryString = this.getQueryString();
      return this.networkManager.requests
        .bulletinSearch(queryString)
        .then(data => {
          data.searchParameters = {
            radius: 0,
            tags: []
          };
          // Give that data to the parent component so it can display updated results
          this.props.searchCallback(data);
        })
        .catch(error =>
          console.error("Error while querying for data: " + error)
        );
    }
  }

  render() {
    return (
      <div ref={this.component}>
        <input
          ref={this.headerInput}
          type="search"
          placeholder={this.props.intl.formatMessage({
            id: "type"
          })}
        />
        <br />
        <input
          ref={this.issueSiteInput}
          type="search"
          placeholder={this.props.intl.formatMessage({
            id: "Originator"
          })}
        />
        <br />
        <SearchInputControls
          onSearch={this.search.bind(this)}
          helpUrl={settings.helpUrlBulletin}
        />
        <hr />
      </div>
    );
  }
}

export default injectIntl(BulletinSearchInput);
